import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * react-native-web-modal
 * @fork https://github.com/Dekoruma/react-native-web-modal
 */
import React, { Component } from 'react';
import { Animated, Dimensions, Easing } from 'react-native';
import ModalPortal from "./Portal";
import * as ariaAppHider from "./ariaAppHider";
import styles from "./styles";

var noop = function noop() {};

var ariaHiddenInstances = 0;

var Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper(Modal);

  _createClass(Modal, null, [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }
  }]);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);

    _this.animateFadeIn = function (callback) {
      if (_this.state.animationFade) {
        _this.state.animationFade.stop();
      }

      var animationFade = Animated.timing(_this.state.opacityFade, {
        toValue: 1,
        duration: 300
      });

      _this.setState({
        animationFade: animationFade
      }, function () {
        requestAnimationFrame(function () {
          _this.setState({
            styleFade: {
              display: 'flex'
            }
          }, function () {
            return _this.state.animationFade.start(callback);
          });
        });
      });
    };

    _this.animateFadeOut = function (callback) {
      if (_this.state.animationFade) {
        _this.state.animationFade.stop();
      }

      var animationFade = Animated.timing(_this.state.opacityFade, {
        toValue: 0,
        duration: 300
      });

      _this.setState({
        animationFade: animationFade
      }, function () {
        requestAnimationFrame(function () {
          _this.state.animationFade.start(function () {
            _this.setState({
              styleFade: {
                display: 'none'
              }
            }, callback);
          });
        });
      });
    };

    _this.animateSlideIn = function (callback) {
      if (_this.state.animationSlide) {
        _this.state.animationSlide.stop();
      }

      var animationSlide = Animated.timing(_this.state.slideTranslation, {
        toValue: 1,
        easing: Easing.out(Easing.poly(4)),
        duration: 300
      });

      _this.setState({
        animationSlide: animationSlide
      }, function () {
        requestAnimationFrame(function () {
          _this.setState({
            styleFade: {
              display: 'flex'
            }
          }, function () {
            return _this.state.animationSlide.start(callback);
          });
        });
      });
    };

    _this.animateSlideOut = function (callback) {
      if (_this.state.animationSlide) {
        _this.state.animationSlide.stop();
      }

      var animationSlide = Animated.timing(_this.state.slideTranslation, {
        toValue: 0,
        easing: Easing["in"](Easing.poly(4)),
        duration: 300
      });

      _this.setState({
        animationSlide: animationSlide
      }, function () {
        requestAnimationFrame(function () {
          _this.state.animationSlide.start(function () {
            _this.setState({
              styleFade: {
                display: 'none'
              }
            }, callback);
          });
        });
      });
    };

    _this.state = {
      animationSlide: null,
      animationFade: null,
      styleFade: {
        display: props.visible ? 'flex' : 'none'
      },
      opacityFade: new Animated.Value(0),
      slideTranslation: new Animated.Value(0)
    };
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.visible) this.handleShow();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var visible = _ref.visible;
      if (visible && !this.props.visible) this.handleShow();
      if (!visible && this.props.visible) this.handleClose();
    }
  }, {
    key: "getAnimationStyle",
    value: function getAnimationStyle() {
      var _this$props = this.props,
          visible = _this$props.visible,
          animationType = _this$props.animationType;
      var styleFade = this.state.styleFade;

      if (animationType === 'slide') {
        return [{
          transform: [{
            translateY: this.state.slideTranslation.interpolate({
              inputRange: [0, 1],
              outputRange: [Dimensions.get('window').height, 0],
              extrapolate: 'clamp'
            })
          }]
        }, styleFade];
      }

      if (animationType === 'fade') {
        return [{
          opacity: this.state.opacityFade
        }, styleFade];
      }

      return [styles[visible ? 'visible' : 'hidden']];
    } // Fade Animation Implementation

  }, {
    key: "handleShow",
    // End of Slide Animation Implementation
    value: function handleShow() {
      var _this$props2 = this.props,
          animationType = _this$props2.animationType,
          _this$props2$onShow = _this$props2.onShow,
          onShow = _this$props2$onShow === void 0 ? function () {
        return null;
      } : _this$props2$onShow,
          ariaHideApp = _this$props2.ariaHideApp,
          appElement = _this$props2.appElement;

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      if (animationType === 'slide') {
        this.animateSlideIn(onShow);
      } else if (animationType === 'fade') {
        this.animateFadeIn(onShow);
      } else {
        onShow();
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      var _this$props3 = this.props,
          animationType = _this$props3.animationType,
          _this$props3$onDismis = _this$props3.onDismiss,
          onDismiss = _this$props3$onDismis === void 0 ? noop : _this$props3$onDismis,
          ariaHideApp = _this$props3.ariaHideApp,
          appElement = _this$props3.appElement;

      if (animationType === 'slide') {
        this.animateSlideOut(onDismiss);
      } else if (animationType === 'fade') {
        this.animateFadeOut(onDismiss);
      } else {
        onDismiss();
      }

      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          transparent = _this$props4.transparent,
          children = _this$props4.children;
      var transparentStyle = transparent ? styles.bgTransparent : styles.bgNotTransparent;
      var animationStyle = this.getAnimationStyle();
      return /*#__PURE__*/React.createElement(ModalPortal, null, /*#__PURE__*/React.createElement(Animated.View, {
        "aria-modal": "true",
        style: [styles.baseStyle, transparentStyle, animationStyle]
      }, children));
    }
  }]);

  return Modal;
}(Component);

export { Modal as default };